// THEME FILES
// -----------
// VENDOR FILES
// -----------
import '../../source/vendor/bootstrap-5.3.8/dist/js/bootstrap.bundle.min.js';

// CUSTOM CODE
// -----------
import { initAsyncContent } from './modules/async-content.js';
import { initArticleTOC } from './modules/article-toc.js';
import { initCarousel } from './modules/carousel.js';
import { initCarouselAutoplayToggle } from './modules/carousel-autoplay-toggle.js';
import { initCarouselInsertButton } from './modules/carousel-insert-button.js';
import { initCarouselPaginationInSlide } from './modules/carousel-pagination-in-slide.js';
import { initChecklist } from './modules/checklist.js';
import { initCopyToClipboard } from './modules/copy-to-clipboard.js';
import { initExternalLinks } from './modules/external-links.js';
import { initDesktopMenu, initMobileMenu } from './modules/menu.js';
import { initHeroVideo } from './modules/video.js';
import { initMoneyGoalsPlaybooks } from './modules/money-goals-playbooks.js';
import { initMoneyGoalsScroll } from './modules/money-goals-scroll.js';
import { initTabKeyboardNav } from './modules/tabs.js';
import { initCategorySelect } from './modules/cards-select.js';
import { initCardsReorder } from './modules/cards-reorder.js';
import { initDynamicCarousel } from './modules/carousel-dynamic.js';
import { initCarouselSidebarAnchor } from './modules/carousel-sidebar-anchor.js';
import { initCardsFilterDropdown } from './modules/cards-filter-dropdown.js';
import { initParallaxSplitImages } from './modules/parallax-split-images.js';
import { initLearningCenterDropdownSelection } from './modules/learning-center-dropdown-selection.js';
import { initScreenNavigation } from './modules/screen-navigation.js';
import { initSearchFormClear } from './modules/search-form-clear.js';
import { initCardPostImageLabeling } from './modules/card-post-image-labeling.js';
import { initHeroSingleH1 } from './modules/hero-single-h1.js';
import { initH1JumpIds } from './modules/h1-jump-ids.js';

/*
 * PaceCore carousel blocks mount from plugin JavaScript on DOMContentLoaded.
 * Inject the autoplay toggle before that event so Splide can find the button
 * during its normal mount process and bind its built-in play/pause behavior.
 */
initCarouselAutoplayToggle();

/**
 * Initialize all theme functionality
 *
 * @since 1.0.0
 */
document.addEventListener('DOMContentLoaded', function () {
    initCarouselAutoplayToggle();
    initDesktopMenu();
    initMobileMenu();
    initAsyncContent();
    initCarouselSidebarAnchor();
    initDynamicCarousel();
    initArticleTOC();
    initCarousel();
    initCarouselInsertButton();
    initCarouselPaginationInSlide();
    initChecklist();
    initCopyToClipboard();
    initExternalLinks();
    initHeroVideo();
    initMoneyGoalsPlaybooks();
    initMoneyGoalsScroll();
    initTabKeyboardNav();
    initCategorySelect();
    initCardsReorder();
    initCardsFilterDropdown();
    initParallaxSplitImages();
    initLearningCenterDropdownSelection();
    initScreenNavigation();
    initSearchFormClear();
    initCardPostImageLabeling();
    initHeroSingleH1();
    initH1JumpIds();
});
